import React from "react";
import { OverlayInterface, TemplateInterface, ArrayHelper, PendingCommand, QuestionInterface, AnswerInterface } from "../../helpers";
import { Row, Col, FormControl, FormGroup, FormLabel, Button } from "react-bootstrap"
import { OverlayAnswers } from ".";
import { ImageEditor } from "../../components";

interface Props {
  overlay: OverlayInterface,
  templates: TemplateInterface[],
  onUpdate: (overlay: OverlayInterface) => void
}

export const OverlayEdit: React.FC<Props> = props => {

  const [overlay, setOverlay] = React.useState<OverlayInterface>(null);
  const [answersCommand, setAnswersCommand] = React.useState<PendingCommand>(null);
  const [imageEditData, setImageEditData] = React.useState<{ question: QuestionInterface, answer: AnswerInterface }>(null);


  const handleChange = (e: any) => {
    let val = e.currentTarget.value;
    setValue(e.currentTarget.id, val);
  }

  const setValue = (target: string, val: any) => {
    let o: OverlayInterface = { ...overlay };
    switch (target) {
      case "templateId": o.templateId = parseInt(val, 0); break;
      case "position": o.position = val; break;
    }
    setOverlay(o);
  }

  const answersSaved = (answers: AnswerInterface[]) => {
    let o: OverlayInterface = { ...overlay };
    o.answers = answers;
    setOverlay(o);
    props.onUpdate(o);
  }


  const handleAnswersCommand = (cmd: PendingCommand) => {
    if (cmd.action === "editImage") setImageEditData(cmd.parameter);
  }

  const handleDone = (e: React.MouseEvent) => {
    e.preventDefault();
    setAnswersCommand({ action: "save", parameter: "" });
  }

  const getTemplateOptions = () => {
    const result: React.ReactElement[] = [];
    props.templates?.forEach(t => { result.push(<option key={t.id} value={t.id}>{t.name}</option>) });
    return result;
  }


  const getImageEditor = () => {
    if (imageEditData) {
      let aspectRatio = 0;
      try {
        const parts = imageEditData.question.choices.split(",");
        aspectRatio = parseFloat(parts[0]) / parseFloat(parts[1]);
      } catch { }
      return <ImageEditor startingUrl={imageEditData.answer.value} updatedFunction={handleImageUpdate} name="imageEditor" aspectRatio={aspectRatio} />
    }
  }


  const handleImageUpdate = (dataUrl: string) => {
    if (dataUrl) {
      let answer: AnswerInterface = { ...imageEditData.answer }
      answer.value = dataUrl;
      setAnswersCommand({ action: "updateAnswer", parameter: answer });
    }
    setImageEditData(null);
  }

  const getPositionOptions = () => {
    const result: React.ReactElement[] = [];
    const t: TemplateInterface = ArrayHelper.getOne(props.templates || [], "id", overlay?.templateId || 0)
    if (t?.positions === "corner") {
      result.push(<option value="top-left">Corner: Top-Left</option>);
      result.push(<option value="top-right">Corner: Top-Right</option>);
      result.push(<option value="bottom-left">Corner: Bottom-Left</option>);
      result.push(<option value="bottom-right">Corner: Bottom-Right</option>);
      if (overlay?.position.indexOf("-") === -1) setValue("position", "top-left");
    } else {
      result.push(<option value="top">Top</option>);
      result.push(<option value="bottom">Bottom</option>);
      if (overlay?.position.indexOf("-") !== -1) setValue("position", "top");
    }
    return result;
  }


  React.useEffect(() => { setOverlay(props.overlay) }, [props.overlay]);

  return (
    <>
      {getImageEditor()}
      <Row>
        <Col>
          <FormGroup className="mb-3">
            <FormLabel htmlFor="mode">Type</FormLabel>
            <FormControl size="sm" as="select" id="templateId" value={overlay?.templateId} onChange={handleChange} >
              {getTemplateOptions()}
            </FormControl>
          </FormGroup>
        </Col>
        <Col>
          <FormGroup className="mb-3">
            <FormLabel htmlFor="position">Position</FormLabel>
            <FormControl size="sm" as="select" name="position" id="position" value={overlay?.position} onChange={handleChange} >
              {getPositionOptions()}
            </FormControl>
          </FormGroup>
        </Col>
      </Row>
      <OverlayAnswers overlay={overlay} pendingCommand={answersCommand} saveCallback={answersSaved} sendCommand={handleAnswersCommand} />
      <Button className="d-grid" size="sm" variant="info" onClick={handleDone}>Update Overlay</Button>
    </>
  );

}